/**
 * Pure helpers for DSP packlist-only inline edit state and save payloads.
 */

export const applyItemQuantityEdit = (
  editedPacklists,
  packlistId,
  item,
  itemQuantity
) => {
  const next = { ...editedPacklists }
  const packlistItem = {
    id: item.id,
    item_id: item.itemId,
    quantity: itemQuantity,
  }

  if (packlistId in next && Array.isArray(next[packlistId].items)) {
    const items = [...next[packlistId].items]
    const itemIndex = items.findIndex((plItem) => plItem.id === item.id)
    if (itemIndex > -1) {
      items[itemIndex] = { ...items[itemIndex], quantity: itemQuantity }
    } else {
      items.push(packlistItem)
    }
    next[packlistId] = { ...next[packlistId], items }
  } else {
    next[packlistId] = { ...(next[packlistId] || {}), items: [packlistItem] }
  }

  return next
}

export const applyCratesEdit = (editedPacklists, values, oriValues) => {
  const next = { ...editedPacklists }
  let changed = false

  Object.keys(values || {}).forEach((key) => {
    const isEdited =
      JSON.stringify(values[key]) !== JSON.stringify(oriValues?.[key])
    const alreadyApplied =
      JSON.stringify(next[key]?.crates) === JSON.stringify(values[key])

    if (isEdited && !alreadyApplied) {
      next[key] = { ...(next[key] || {}), crates: values[key] }
      changed = true
    }
  })

  // Returning the same reference for a repeated edit keeps callers from
  // scheduling a state update that would re-render into this function again.
  return changed ? next : editedPacklists
}

export const buildPacklistUpdatePayload = (packlistEdit) => {
  const payload = {}
  const items = packlistEdit?.items || []

  if (items.length !== 0) {
    payload.items = items
  }

  if (Object.prototype.hasOwnProperty.call(packlistEdit || {}, 'crates')) {
    payload.cratesNew = {
      valid: true,
      cratesList: packlistEdit.crates,
    }
  }

  return payload
}

export const getOverPickingErrorMessage = (item, itemQuantity, getMessage) => {
  const soldByWeight =
    item.soldByWeight &&
    item.unitOfMeasurement &&
    item.unitOfMeasurement === 'KGM'
  const overPickingQty = soldByWeight
    ? (item.orderedQuantity * item.overPickingThreshold).toFixed(2)
    : item.orderedQuantity
  return `${getMessage(
    'deliveryOrder.edit-packed.overpicked.error'
  )}: ${itemQuantity} > ${overPickingQty}`
}

export const saveEditedPacklists = async (editedPacklists, createApi) => {
  const packlistIds = Object.keys(editedPacklists || {})
  if (packlistIds.length === 0) {
    return false
  }

  for (const packlistId of packlistIds) {
    const payload = buildPacklistUpdatePayload(editedPacklists[packlistId])
    if (Object.keys(payload).length === 0) {
      continue
    }
    const api = createApi(`/picking-service/v3/packlists/${packlistId}/update`)
    await api.put(payload)
  }

  return true
}
